import * as React from 'react';

export const SectionIcon = React.forwardRef<
  SVGSVGElement,
  React.ComponentProps<'svg'> & { size?: number }
>(({ size = 16, ...props }, ref) => {
  return (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect
        x="3"
        y="4"
        width="18"
        height="16"
        rx="2"
        stroke="currentColor"
        strokeWidth="2"
        fill="none"
      />
      <rect x="5" y="8" width="14" height="2" rx="1" fill="currentColor" />
      <rect x="5" y="12" width="10" height="2" rx="1" fill="currentColor" />
      <rect x="5" y="16" width="8" height="2" rx="1" fill="currentColor" />
    </svg>
  );
});

SectionIcon.displayName = 'SectionIcon';
